import axios from "axios";

const apiClient = () => {
  const requestHeaders = {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_API_KEY_PUBLIC,
  };
  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}`,
    responseType: "json",
    headers: requestHeaders,
    timeout: 100000,
  });
  return axiosInstance;
};

export default apiClient;
